module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<table class='user-profile-data'>\n    <tr>\n        <td class='user-profile-data-label'>фио</td>\n        <td>\n			<div class='user-profile-data-fio'>")
    ; __append(escapeFn( context("user.name") ))
    ; __append("</div>\n        </td>\n    </tr>\n    <tr>\n        <td class='user-profile-data-label'>логин</td>\n        <td>")
    ; __append(escapeFn( context("user.login") ))
    ; __append("</td>\n    </tr>\n    <tr>\n        <td class='user-profile-data-label'>роль</td>\n        <td>")
    ; __append(escapeFn( context("role.name") ))
    ; __append("</td>\n    </tr>\n    <tr>\n        <td class='user-profile-data-label'>поставщик</td>\n        <td>")
    ; __append(escapeFn( context("provider.name") ))
    ; __append("\n			<br/><small class=\"dsub\" style=\"margin-left: 10px;\">")
    ; __append(escapeFn( context("provider.subname") ))
    ; __append("</small></td>\n    </tr>\n</table>")
  }
  return __output.join("");

}